export default __webpack_public_path__ + "static/media/Efficiensee AI Light.b63e1cd9.svg";